import { useGetDealerDetailsQuery } from '@api/customer.api';
import { ContentLink } from '@api/types';
import {
  BlockContainer,
  CreateCustomerModal,
  DealerDetailsForm,
  DealerDetailsHeader,
  DealerDetailsProvider,
  DealerDetailsSkeleton,
  DeleteCustomerModal,
  LoadingError,
} from '@components';
import { useAppSelector, useAuth } from '@hooks';
import { Box, styled } from '@mui/material';
import { getSpecialPage } from '@store/app/app.slice';
import { useLocation } from 'react-router-dom';
// STYLES
//--------
const DealerDetailsBlockWrapper = styled(Box)``;

// TYPES
//-------
type DealerDetailsBlockProps = {
  title?: string;
  children?: React.ReactNode;
  contentLink?: ContentLink;
};

// COMPONENTS
//------------
export const DealerDetailsBlock = ({ title, children, contentLink }: DealerDetailsBlockProps) => {
  const location = useLocation();
  const { pathname } = location;
  const detailPathname = useAppSelector(getSpecialPage('dealerDetailsPage')) as string;
  const { customerNo } = useAuth();
  const urlParams = new URLSearchParams(location.search);
  const searchParamId = urlParams.get('id');
  const id = !searchParamId || isNaN(Number(searchParamId)) ? customerNo : searchParamId ?? null;
  const { isError, isFetching, isLoading } = useGetDealerDetailsQuery(id || '', { skip: !id });
  const isWorking = isFetching || isLoading;
  const isLoadingError = (isError || !id) && pathname === detailPathname;
  const contentLinkId = contentLink?.id;

  if (isWorking) {
    return <DealerDetailsSkeleton />;
  }
  return (
    <BlockContainer>
      <DealerDetailsBlockWrapper className='dealer-details-block'>
        {isLoadingError ? (
          <LoadingError />
        ) : (
          <DealerDetailsProvider>
            <DealerDetailsHeader title={title} contentLinkId={contentLinkId} />
            <DealerDetailsForm isWorking={isWorking} dealerId={id} contentLinkId={contentLinkId} />
            <CreateCustomerModal />
            <DeleteCustomerModal />
            {children}
          </DealerDetailsProvider>
        )}
      </DealerDetailsBlockWrapper>
    </BlockContainer>
  );
};
